var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormField',[_c('ZoneEditor',{attrs:{"maxSelections":0,"minSelections":0},on:{"selectedCategory":_vm.onSelectedCategory,"removeCategory":_vm.onRemoveCategory},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }